<template>
  <div class="lg:px-12 md:px-12 px-5 lg:py-8 md:py-10 py-8 bg-f3">
    <p
      class="title text-center text-primary sm-fsize16 md:font-normal lg:font-normal font-semibold lg:pl-2 md:pl-2 pl-6 mx-auto"
    >
      Partners
    </p>
    <div
      class="flex flex-wrap justify-between lg:px-12 md:px-12 px-0 lg:py-12 md:py-12 py-6"
    >
      <swiper class="swiper swiper2" :options="swiperOptions">
        <!-- v-for="(item, index) in 6" :key="index" -->
        <!-- <swiper-slide
            v-for="(item, index) in partners"
            :key="'item -' + index"
            c
          >
            <div class="lg:px-8">
              <img
                :src="item.image"
                alt="Avatar"
                :class="item && item.class ? item.class : ''"
                class="flex md:h-32 lg:h-32 md:w-32 lg:w-32 w-12 sm-partner-w img-ratio"
              />
            </div>
          </swiper-slide> -->
        <swiper-slide
          v-for="(item, index) in campaignPartner.result"
          :key="'partner-' + index"
        >
          <div class="lg:px-8">
            <a :href="item.link" target="_blank">
              <img
                :src="`${$imageURL}/${item.image}`"
                :alt="item.title"
                class="flex md:h-32 lg:h-32 md:w-40 lg:w-40 w-12 sm-partner-w img-ratio"
              />
            </a>
          </div>
        </swiper-slide>

        <!-- <div class="swiper-pagination cust-posi" slot="pagination"></div> -->
        <div class="swiper-button-prev custarrow" slot="button-prev"></div>
        <div class="swiper-button-next custarrow" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 20,
        loop: true,
        // pagination: {
        //   el: ".swiper-pagination",
        // },

        breakpoints: {
          1600: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
          575: {
            slidesPerView: 2,
            spaceBetween: 25,
            slidesPerColumn: 1,
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },
      partners: [
        // {
        //   image: require("@/assets/images/PartnerLogos/CanSupport-logo.png"),
        // },
        // {
        //   image: require("@/assets/images/CGNEW/aajicare.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo1.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/kewalcare.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo0.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/toward Equal.png"),
        //   class: "object-contain",
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo3.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo4.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo5.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo6.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo7.png"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo8.jpg"),
        // },
        // {
        //   image: require("@/assets/images/partner/mainlogo9.jpg"),
        // },
        // {
        //   image: require("@/assets/images/CGNEW/fellow.png"),
        // },
        // {
        //   image: require("@/assets/images/CGNEW/walmart.jpeg"),
        // },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async loadPartners() {
      await this.$store.dispatch("campaignPageBanner/get_partner");

      console.log("1234", this.campaignPartner);
    },
  },
  mounted() {
    this.loadPartners();
  },
  computed: {
    ...mapState("campaignPageBanner", { campaignPartner: "campaignPartner" }),
  },
};
</script>
<style></style>
